import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formatPrice, convertDate, formatURL } from '../../../utils';

import {
  clearCoupon,
  setCouponText,
  openModalDetail,
  openModalPlanRules,
  cleanErrors,
  cleanStatesPurchaseMobile,
} from '../../../actions/purchaseActions';

import Tag from '../../common/Tags';

class PurchaseSummary extends Component {
  constructor(props) {
    super(props);

    this.activeSummary = this.activeSummary.bind();

    const destinationFiltered = this.props.destinations.filter(
      (destination) => destination.slug === this.props.match.params.destination
    );

    this.destination = this.props.destinations && destinationFiltered.length ? destinationFiltered[0].name : '';
  }

  state = {
    active: false,
  };

  activeSummary = () => {
    this.setState({ active: !this.state.active });
  };

  backSearch = (e) => {
    const location = {
      pathname: formatURL(
        this.props.match,
        `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
        null
      ),
    };
    this.props.cleanStatesPurchaseMobile();
    this.props.cleanErrors();
    this.props.history.push(location);
  };

  renderPrice = () => {
    const plan = this.props.plan[0];

    if (this.props.purchaseSummary.coupon_discount && !this.props.purchaseSummary.total) return formatPrice('0,00');
    else if (this.props.purchaseSummary.total) return formatPrice(this.props.purchaseSummary.total);
    else return formatPrice(plan.adult.price);
  };

  render() {
    if (!this.props.plan[0]) return <div />;

    const plan = this.props.plan[0];

    return (
      <div
        className={`purchase-summary ${this.state.active && 'active'}`}
        style={{ display: this.props.stagePurchase === 4 ? 'none' : 'block' }}
      >
        {!this.state.active && (
          <div className="purchase-summary-disable" onClick={this.activeSummary}>
            <div className="disable-header">
              <span>
                Ver resumo da compra: <strong>R$ {this.renderPrice()}</strong>
              </span>
              <img src="/assets/images/pagamento/up.svg" alt="" />
            </div>
          </div>
        )}
        {this.state.active && (
          <div className="purchase-summary-info">
            <div className="info-header">
              <span>Resumo da compra</span>
              <span onClick={this.activeSummary}>
                <img src="/assets/images/pagamento/up.svg" alt="" className="rotate-svg" />
              </span>
            </div>

            <div className="info-body">
              <div className="box-plan box-insured">
                <ul className="lista-passageiros">
                  {this.props.purchaseSummary.elder.qte > 0 && (
                    <li className="flex">
                      <span>
                        {this.props.purchaseSummary.elder.qte} Adulto
                        {this.props.purchaseSummary.elder.qte > 1 ? 's' : ''} (maior de {plan.adult.max_age} anos)
                      </span>
                      <span>R$ {formatPrice(this.props.purchaseSummary.elder.price)}</span>
                    </li>
                  )}

                  {this.props.purchaseSummary.adult.qte > 0 && (
                    <li className="flex">
                      <span>
                        {this.props.purchaseSummary.adult.qte} Adulto
                        {this.props.purchaseSummary.adult.qte > 1 ? 's' : ''}
                      </span>
                      <span>R$ {formatPrice(this.props.purchaseSummary.adult.price)}</span>
                    </li>
                  )}

                  {this.props.purchaseSummary.child.qte > 0 && (
                    <li className="flex">
                      <span>
                        {this.props.purchaseSummary.child.qte} Criança
                        {this.props.purchaseSummary.child.qte > 1 ? 's' : ''} (até {plan.child.max_age} anos)
                      </span>
                      <span>R$ {formatPrice(this.props.purchaseSummary.child.price)}</span>
                    </li>
                  )}

                  {this.props.purchaseSummary.invalid.qte > 0 && (
                    <React.Fragment>
                      <li className="flex">
                        <span>
                          {this.props.purchaseSummary.invalid.qte} Adulto
                          {this.props.purchaseSummary.invalid.qte > 1 ? 's' : ''} (idade incompatível com o plano)
                        </span>
                        <span className="back-search" onClick={this.backSearch}>
                          <u>Voltar à pesquisa</u>
                        </span>
                      </li>
                    </React.Fragment>
                  )}
                </ul>

                <hr />

                <ul className="lista-subtotal">
                  <li className="flex">
                    <span className="title-subtotal">Subtotal</span>
                    <span>R$ {formatPrice(this.props.purchaseSummary.subtotal || plan.adult.price)}</span>
                  </li>

                  {this.props.purchaseSummary.paymentMethodDiscountValue > 0 && (
                    <li className="flex">
                      <span>Desconto {this.props.purchaseSummary.paymentMethodSelected}</span>
                      <span>- R$ {formatPrice(this.props.purchaseSummary.paymentMethodDiscountValue)}</span>
                    </li>
                  )}

                  {this.props.purchaseSummary.coupon_discount > 0 && (
                    <li className="flex">
                      <span>Desconto Cupom</span>
                      <span>- R$ {formatPrice(this.props.purchaseSummary.coupon_discount)}</span>
                    </li>
                  )}

                  <li className="flex row-total">
                    <span className="text-total">Total</span>
                    <span className="total-resumo-compra">R$ {this.renderPrice()}</span>
                  </li>
                </ul>
              </div>

              <div className="box-plan plan-bottomsheet-mobile">
                <Tag plan={plan} isMobile />

                <h4 className="plan-title">{plan.name}</h4>

                <hr />

                <div className="more-info-plan">
                  <div className="more-info-plan-item">
                    <img src="/assets/images/icons/destiny.svg" alt="" />
                    <span>Destino:</span>
                    <span>{this.destination}</span>
                  </div>
                  <div className="more-info-plan-item">
                    <img src="/assets/images/icons/calendar.svg" alt="" />
                    <span>
                      {convertDate(this.props.match.params.begin_date)} -{' '}
                      {convertDate(this.props.match.params.end_date)}
                    </span>
                  </div>
                  <div className="more-info-plan-item">
                    <img src="/assets/images/icons/cash.svg" alt="" />
                    <span>Preço por dia:</span>
                    <span>R$ {formatPrice(this.props.purchaseSummary.investmentPerDay)}</span>
                  </div>
                </div>

                <div className="more-info-plan-links">
                  <button className="ver-mais green" onClick={this.props.openModalDetail}>
                    Cobertura completa
                  </button>

                  <button onClick={this.props.openModalPlanRules} className="plan-rules purple">
                    Informações e Regras do Plano
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      plan: state.search.plans,
      couponInfo: state.purchase.coupon,
      payment_methods: state.purchase.paymentMethods,
      purchaseSummary: state.purchase.purchaseSummary,
      stagePurchase: state.purchase.stagePurchase,
    }),
    {
      clearCoupon,
      setCouponText,
      openModalDetail,
      openModalPlanRules,
      cleanErrors,
      cleanStatesPurchaseMobile,
    }
  )(PurchaseSummary)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_summary/PurchaseSummary.jsx